import { sendGAEvent } from './gaConsent';

/**
 * Utility function to track button clicks in Google Analytics
 * @param {string} category
 * @param {string} action
 * @param {string} label
 * @param {Object} additionalParams
 */
export const trackButtonClick = (category, action = 'click', label, additionalParams = {}) => {
  try {
    sendGAEvent({
      category,
      action,
      label,
      ...additionalParams,
    });
  } catch (error) {
    console.warn('Analytics tracking error:', error);
  }
};

/**
 * Track home page main button clicks with unique IDs
 */
export const trackHomeButtonClick = (buttonName, buttonId) => {
  trackButtonClick('Home', 'click', buttonName, {
    custom_parameter_1: buttonId,
    button_id: buttonId,
  });
};

/**
 * Track feedback button actions
 */
export const trackFeedbackAction = action => {
  trackButtonClick('Feedback', action, 'Feedback Button');
};

/**
 * Track browse all tab clicks
 */
export const trackBrowseTabClick = tabName => {
  trackButtonClick('Browse', 'tab_click', tabName);
};

/**
 * Track filter management actions
 */
export const trackFilterAction = action => {
  trackButtonClick('Filters', action, 'Manage Filters');
};

/**
 * Track save filter management actions
 */
export const trackSaveFilterAction = action => {
  trackButtonClick('Filters', action, 'Save Filters');
};

/**
 * Track enrichment analysis actions
 */
export const trackEnrichmentAction = (action, source = '') => {
  trackButtonClick('Enrichment', action, source ? `${action}_${source}` : action);
};
